import {createModel} from '@@/package/utils/ModelUtil';
import Model from '@@/package/mapper/Model';

export class UserModel extends Model {
    constructor(
        public id: number = 0,
        public nickName: string = "",
        public fullName: string = "",
        public givenName: string = "",
        public familyName: string = "",
        public point: number = 0,
        public email: string = "",
        public emailAuthFlag: boolean = false,
        public locale: string = "",
        public organizationId: number = 0,
        public password: string = "",
        public profileImageUrl: string = "",
        public provider: string = "",
        public status: string = "",
        public type: string = "",
        public jobTitle: string = "",
        public organizationName: string = "",
        public location: string = "",
        public trackSkipFlag: boolean = false,
        public recentAccessDate: number = new Date().getTime(),
        public createdAt: number = new Date().getTime(),
        public updatedAt: number = new Date().getTime()
    ) {
        super();
    }

    public static create(model: Partial<UserModel>): UserModel {
        return createModel<UserModel>(UserModel, {
            ...model
        });
    }
}
